import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faTimesCircle,
  faHourglassHalf,
} from '@fortawesome/pro-solid-svg-icons'

import { CourseEvaluationState } from 'enum/courseEvaluation-state.enum'
import { prefix } from '../../constants'
import styles from './Evaluations.module.scss'
import { Col, Row } from 'react-bootstrap'
import BasePopover from 'components/monitoring/components/BasePopover'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import { Course, CourseUser } from 'graphqlAPI'
import { useMemo } from 'react'

interface EvaluationsProps {
  state?: number | null
  courseUser: CourseUser
  course?: Course
}

export const Evaluations = ({
  state,
  courseUser,
  course,
}: EvaluationsProps) => {
  const { t } = useTranslation()
  const prefixColumns = `${prefix}.columns`
  const prefixContent = `${prefix}.content`
  const { evaluationsCount } = useSelector(
    ({ courses }: IMainState) => courses.course
  )

  const { synchronousCourseEvaluationsCount } = { ...course }

  const { synchronousCourseEvaluations } = courseUser

  const popoverContent = useMemo(
    () => (
      <>
        {new Array(evaluationsCount || 0).fill(0).map((_, index) => {
          const evaluation = courseUser.evaluations?.[index]
          const name = t(`${prefixContent}.evaluations`, {
            name: `${index + 1}`,
          })
          return (
            <Col key={index} xs={12}>
              <Row>
                <Col xs>{name}:</Col>
                <Col
                  xs="auto"
                  className={
                    (evaluation?.approved === false && styles.reproved) || ''
                  }
                >
                  {evaluation?.points ?? <div className="mx-1">-</div>}
                </Col>
              </Row>
            </Col>
          )
        })}
        {new Array(synchronousCourseEvaluationsCount || 0)
          .fill(0)
          .map((_, index) => {
            const evaluation = synchronousCourseEvaluations?.[index]
            const name = t(`${prefixContent}.synchronousCourseEvaluation`, {
              name: `${index + 1}`,
            })
            return (
              <Col key={index} xs={12}>
                <Row>
                  <Col xs>{name}:</Col>
                  <Col xs="auto">
                    {evaluation?.qualification ?? <div className="mx-1">-</div>}
                  </Col>
                </Row>
              </Col>
            )
          })}
      </>
    ),
    [
      evaluationsCount,
      synchronousCourseEvaluationsCount,
      courseUser.evaluations,
      t,
      prefixContent,
      synchronousCourseEvaluations,
    ]
  )

  const { approved, failed } = CourseEvaluationState
  return (
    <div className={styles.evaluationResultsContainer}>
      <BasePopover popoverContent={<Row>{popoverContent}</Row>}>
        <div className={styles.state}>
          <FontAwesomeIcon
            className={`mr-1 `}
            icon={
              state === approved
                ? faCheckCircle
                : state === failed
                ? faTimesCircle
                : faHourglassHalf
            }
          />
          {t(
            `${prefixColumns}.evaluations.${
              state === approved
                ? 'approved'
                : state === failed
                ? 'failed'
                : 'inProcess'
            }`
          )}
        </div>
      </BasePopover>
    </div>
  )
}
